import { render, staticRenderFns } from "./ClientCallHistory.vue?vue&type=template&id=a4404256"
import script from "./ClientCallHistory.vue?vue&type=script&lang=js"
export * from "./ClientCallHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports